import Common from '../common.js';

export default {

    sendAppeal: function (appeal, successCallback, errorCallback) {
        var result = null;
        $.ajax({
            url: Application.getBasePath() + '/api/appeal/save',
            type: 'POST',
            data: $.toJSON(appeal),
            dataType: "json",
            async: false,
            contentType: 'application/json',
            success: function (data, textStatus) {
                result = data.id;
                // Common.showToast('success', 'Успех', 'Обращение успешно сохранено');
                if (successCallback != null) {
                    successCallback(result);
                }
            },
            error: function (jqXHR, data, textStatus) {
                console.log('catched!');
                var obj = jQuery.parseJSON(jqXHR.responseText);
                // Common.showToast('error', 'Ошибка', obj.message);
                if (errorCallback != null) {
                    errorCallback(data);
                }
            }
        });
        return result;

    },

    appeals: function (start, pageSize, enrich, async, filterParams, successCallback, errorCallback) {
        var queryParams = '?enrich=' + enrich + '&count=' + pageSize + '&start=' + start;
        if (start === null || pageSize === null) {
            queryParams = '?enrich=' + enrich;
        }
        if (filterParams !== null) {
            for (var key in filterParams) {
                let val = filterParams[key];
                console.log(val)
                if (val !== undefined && val !== '') {
                    queryParams += ('&' + key + '=' + val);
                }
            }
        }
        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/api/appeal' + queryParams,
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },

    appealStatuses: function (enrich, async, successCallback, errorCallback) {

        var d = null;
        $.ajax({
            url: Application.getBasePath() + '/api/appeal/status',
            type: 'GET',
            dataType: "json",
            async: async,
            contentType: 'application/json', xhrFields: {withCredentials: true},
            success: function (data, textStatus) {
                d = data;
                if (successCallback != null) {
                    successCallback(data);
                }
            },
            error: function (jqXHR, data, textStatus) {
                var obj = jQuery.parseJSON(jqXHR.responseText);
                if (errorCallback != null) {
                    errorCallback(obj.message);
                }
            }
        });

        return d;
    },



};


// WEBPACK FOOTER //
// ./src/api/appeal.js